import { QuestionDayTripPlanIsHiddenHotelQuestions } from "./is-hidden-hotel-questions";
import { QuestionDayTripPlanPreQuestions } from "./pre-questions/pre-questions";

export const QuestionPlanPreQuestionsRoot = () => {
	return (
		<>
			<QuestionDayTripPlanIsHiddenHotelQuestions />
			<QuestionDayTripPlanPreQuestions />
		</>
	);
};

QuestionPlanPreQuestionsRoot.displayName = "QuestionPlanPreQuestionsRoot";
